import { Box, Button, Tab, Tabs } from "@mui/material"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import TabFilterResults from "./TabFilterResults"
import TabFilterSettings from "./TabFilterSettings"
import TabFilterDescription from "./TabFilterDescription"

const PanelFilterDetail = (props) => {
	const navigate								= useNavigate()
	const screenerId							= props.screenerId
	const [currentTabIndex, setCurrentTabIndex]	= useState(0) // Se ID veio zero, entao está criando um novo filtro

	return (
		<Box height="100%">
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }} display={'flex'} alignItems={'center'} justifyContent={'right'}>
				<Box flex={1}>
				<Tabs value={currentTabIndex} onChange={(e, tabIndex) => setCurrentTabIndex(tabIndex)} variant="scrollable" allowScrollButtonsMobile  scrollButtons="auto" >					
					<Tab key="0" label="Visão Geral" />
					<Tab key="1" label="Parâmetros" />
					<Tab key="2" label="Resultados" />
				</Tabs>
				</Box>
				<Box display="flex" gap={1}>
					<Button variant="contained" onClick={() => navigate('/stockscreener')}>Voltar para Listagem</Button>
				</Box>
			</Box>

			{ currentTabIndex === 0 ? (<TabFilterDescription screenerId={screenerId}/>) : null }
			{ currentTabIndex === 1 ? (<TabFilterSettings screenerId={screenerId} onSaveSucess={() => setCurrentTabIndex(2)}/>) : null }
			{ currentTabIndex === 2 ? (<TabFilterResults screenerId={screenerId}/>) : null }
		</Box>
	)
}

export default PanelFilterDetail
